<template>
  <div class="profile-wrapper">
    <slot></slot>
    <div class="profile" v-if="show">
      <div class="profile-arrow"></div>
      <div class="profile-content" v-click-outside="onClickOutside">
        <!-- <div class="profile-content__image">
          <img src="@img/user-2.svg" alt="profile photo">
        </div> -->

        <div class="profile-content__name">
          <p>{{ String(profileData.first_name) + ' ' + String(profileData.last_name) }}</p>
        </div>

        <div class="username">
          <p>{{ profileData.username }}</p>
        </div>

        <div class="profile-content__email">
          <p>{{ String(profileData.email) }}</p>
        </div>

        <language-changer/>

        <div class="line"></div>

        <div class="profile-content__items">

          <a href="https://dgearth.ru/lk/profile">
            <div class="profile-content__item">
              <div class="item-image">
                <svg viewBox="-42 0 512 512.002" xmlns="http://www.w3.org/2000/svg"><path :class="[serviceName + '-color']" d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0"/><path :class="[serviceName + '-color']" d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0"/></svg>
              </div>
              <div class="item-text">
                <p class="item-text__title">
                  {{ locale === 'en' ? 'Profile' : 'Профиль' }}
                </p>
                <p class="item-text__sub-title">{{ locale === 'en' ? 'User information' : 'Полная информация о пользователе' }}</p>
              </div>
            </div>
          </a>

          <a href="https://dgearth.ru/lk/orders-list">
            <div class="profile-content__item">
              <div class="item-image">
                <svg height="512pt" viewBox="0 -31 512.00033 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path :class="[serviceName + '-color']" d="m166 300.003906h271.003906c6.710938 0 12.597656-4.4375 14.414063-10.882812l60.003906-210.003906c1.289063-4.527344.40625-9.390626-2.433594-13.152344-2.84375-3.75-7.265625-5.964844-11.984375-5.964844h-365.632812l-10.722656-48.25c-1.523438-6.871094-7.617188-11.75-14.648438-11.75h-91c-8.289062 0-15 6.710938-15 15 0 8.292969 6.710938 15 15 15h78.960938l54.167968 243.75c-15.9375 6.929688-27.128906 22.792969-27.128906 41.253906 0 24.8125 20.1875 45 45 45h271.003906c8.292969 0 15-6.707031 15-15 0-8.289062-6.707031-15-15-15h-271.003906c-8.261719 0-15-6.722656-15-15s6.738281-15 15-15zm0 0"/><path :class="[serviceName + '-color']" d="m151 405.003906c0 24.816406 20.1875 45 45.003906 45 24.8125 0 45-20.183594 45-45 0-24.8125-20.1875-45-45-45-24.816406 0-45.003906 20.1875-45.003906 45zm0 0"/><path :class="[serviceName + '-color']" d="m362.003906 405.003906c0 24.816406 20.1875 45 45 45 24.816406 0 45-20.183594 45-45 0-24.8125-20.183594-45-45-45-24.8125 0-45 20.1875-45 45zm0 0"/></svg>
              </div>
              <div class="item-text">
                <p class="item-text__title">{{ locale === 'en' ? 'Orders' : 'Заказы' }}</p>
                <p class="item-text__sub-title">{{ locale === 'en' ? 'Current orders' : 'Текущие заказы' }}</p>
              </div>
            </div>
          </a>

          <a :href="logoutUrl">
            <div class="profile-content__item">
              <div class="item-image">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 512.005 512.005" style="enable-background:new 0 0 512.005 512.005;" xml:space="preserve">
                <g>
                  <g>
                    <g>
                      <path :class="[serviceName + '-color']" d="M192,256.003c0-35.285,28.715-64,64-64h85.333V21.336c0-11.776-9.536-21.333-21.333-21.333H21.333
                        C9.536,0.003,0,9.56,0,21.336v469.333c0,11.776,9.536,21.333,21.333,21.333H320c11.797,0,21.333-9.557,21.333-21.333V341.336
                        v-21.333H256C220.715,320.003,192,291.288,192,256.003z"/>
                      <path :class="[serviceName + '-color']" d="M507.201,269.48c0.065-0.079,0.119-0.164,0.182-0.244c0.366-0.462,0.721-0.933,1.048-1.425
                        c0.154-0.23,0.284-0.47,0.428-0.705c0.216-0.353,0.437-0.703,0.632-1.069c0.161-0.3,0.296-0.61,0.441-0.916
                        c0.15-0.317,0.309-0.629,0.444-0.954c0.145-0.35,0.263-0.707,0.388-1.062c0.104-0.295,0.219-0.585,0.31-0.886
                        c0.127-0.418,0.224-0.841,0.325-1.264c0.059-0.248,0.131-0.491,0.182-0.742c0.117-0.581,0.199-1.166,0.267-1.753
                        c0.012-0.101,0.033-0.199,0.043-0.301c0.145-1.434,0.145-2.88,0-4.314c-0.01-0.102-0.032-0.2-0.043-0.301
                        c-0.068-0.587-0.151-1.172-0.267-1.753c-0.05-0.251-0.122-0.494-0.182-0.742c-0.101-0.423-0.198-0.847-0.325-1.264
                        c-0.091-0.301-0.206-0.591-0.31-0.886c-0.126-0.355-0.243-0.713-0.388-1.062c-0.135-0.325-0.293-0.637-0.444-0.954
                        c-0.145-0.306-0.28-0.615-0.441-0.916c-0.196-0.366-0.416-0.716-0.632-1.069c-0.144-0.235-0.274-0.475-0.428-0.705
                        c-0.327-0.492-0.682-0.963-1.048-1.425c-0.063-0.08-0.117-0.164-0.182-0.244c-0.48-0.589-0.991-1.151-1.531-1.685l-85.254-85.254
                        c-8.341-8.341-21.824-8.341-30.165,0c-8.341,8.341-8.341,21.824,0,30.165l48.917,48.917H256
                        c-11.797,0-21.333,9.557-21.333,21.333c0,11.776,9.536,21.333,21.333,21.333h183.168l-48.917,48.917
                        c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251l85.254-85.254
                        C506.209,270.631,506.72,270.069,507.201,269.48z"/>
                    </g>
                  </g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                </svg>
              </div>
              <div class="item-text">
                <p class="item-text__title">{{ locale === 'en' ? 'Log out' : 'Выход' }}</p>
                <p class="item-text__sub-title">{{ locale === 'en' ? 'Log out' : 'Выход из учетной записи' }}</p>
              </div>
            </div>
          </a>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appStore from '@storages/appStore'
import languageChanger from '@/components/common/languageChanger'

export default {
  name: 'profile',
  props: ['show'],

  components: {
    'language-changer': languageChanger
  },

  computed: {
    locale () {
      return appStore.getters.value('locale')
    },
    profileData () {
      return appStore.getters.value('profile')
    },
    logoutUrl () {
      return appStore.getters.value('config').auth_logout_url
    },
    serviceName () {
      return appStore.getters.value('name')
    }
  },

  methods: {
    closeItem () {
      this.$emit('close-item')
    },

    onClickOutside (event) {
      this.closeItem()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/varibles.scss';
.eco-color {
  fill: $eco-color;
}
.emergency-color {
  fill: $emergency-color;
}
.quarry-color {
  fill: $quarry-color;
}
.construction-color {
  fill: $construction-color;
}
.legal-color {
  fill: $legal-color;
}
.agro-color {
  fill: $agro-color;
}
.forest-color {
  fill: $forest-color;
}
a {
  color: black;
  text-decoration: none;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
:focus {
  outline: 0;
}
.profile {
  position: absolute;
  z-index: 10;
  top: 60px;
  right: 6px;
  // width: 350px;
  width: min-content;
}
.profile-arrow {
  width: 0;
  height: 0;
  border-bottom: 14px solid #ffffff;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  float: right;
  margin-right: 22px;
}
.profile-content {
  margin-top: 14px; // высота стрелки
  padding: 20px 0 8px 0;
  border-radius: 10px;
  background-color: white;
  // box-shadow: 0px 14px 38px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 0px 7px 62px 0px rgba(0,0,0,0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-content__image {
  width: 66px;
  height: 66px;
}
.profile-content__image img {
  width: 66px;
  height: 66px;
  object-fit: cover;
  border-radius: 50%;
}
.profile-content__name {
  margin-top: 12px;
}
.profile-content__name p {
  font-size: 18px;
  font-weight: bold;
}
.profile-content__email p {
  font-size: 14px;
  color: #616161;
}

.username {
  font-size: 1.1428571428571428rem;
  font-family: "PT Sans";
  font-weight: 400;
  line-height: 1;
  color: #616161;
  margin-top: -2px;
  // margin-bottom: 3px;
}

.line {
  height: 2px;
  width: calc(100% - 54px);
  background-color: #f6f6f6;
  margin-top: 20px;
}

.profile-content__items {
  margin-top: 9px;
}
.profile-content__item {
  // margin-top: 28px;
  display: flex;
  // width: 100%;
  width: 296px;
  // padding: 15px 27px 12px 27px;
  margin-top: 3px;
  padding: 4px 16px;
}
.profile-content__item:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.item-image {
  height: 31px;
  width: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -2px;
  margin-top: 2px;
}
.item-image svg {
  // width: 27px;
  height: 20px;
}
.item-text {
  margin-left: 11px;
}
.item-text__title {
  color: #616161;
  font-size: 1rem;
  font-family: "PT Sans";
  font-weight: 400;
  line-height: 1;
  margin-bottom: 3px;
}
.item-text__sub-title {
  // font-size: 14px;
  color: rgba(97, 97, 97, 0.48);
  font-size: 1rem;
  font-family: "PT Sans";
  font-weight: 400;
  line-height: 1;
  margin-bottom: 3px;
}
.user-image {
  width: 27px;
  // height: 31px;
}
.orders-image {
  width: 28px;
  height: 29px;
}
.exit-image {
  width: 22px;
  height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/headerItems/ItemProfile.vue